import script from "./FloorPlan3D.vue?vue&type=script&setup=true&lang=js"
export * from "./FloorPlan3D.vue?vue&type=script&setup=true&lang=js"

import "./FloorPlan3D.vue?vue&type=style&index=0&id=66adb278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66adb278"]])

export default __exports__